module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("场次记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生/操作人ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学生 uid，试做则为后台账号 ID"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "考试类型"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择考试类型"
    },
    model: {
      value: (_vm.queryParam.examType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "examType", $$v)
      },
      expression: "queryParam.examType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PLACEMENT"
    }
  }, [_vm._v("入门测")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE"
    }
  }, [_vm._v("阶段测")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场次状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择场次状态"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "CREATED"
    }
  }, [_vm._v("已创建")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "IN_PROGRESS"
    }
  }, [_vm._v("答题中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PAUSED"
    }
  }, [_vm._v("已暂停")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SCORING"
    }
  }, [_vm._v("评分中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "READY"
    }
  }, [_vm._v("已交卷")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "COMPLETED"
    }
  }, [_vm._v("已完成")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "ABANDONED"
    }
  }, [_vm._v("已放弃")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "INCOMPLETE_REF"
    }
  }, [_vm._v("作答不足/待复核")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "INVALID"
    }
  }, [_vm._v("已作废")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场次来源"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择场次来源"
    },
    model: {
      value: (_vm.queryParam.source),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "source", $$v)
      },
      expression: "queryParam.source"
    }
  }, [_c('Option', {
    attrs: {
      "value": "TRIAL"
    }
  }, [_vm._v("试做")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "STUDENT"
    }
  }, [_vm._v("学生考试")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/sessions/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.reportModalTitle,
      "width": "920",
      "class-name": "mex-rpt-modal"
    },
    model: {
      value: (_vm.reportVisible),
      callback: function($$v) {
        _vm.reportVisible = $$v
      },
      expression: "reportVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "78vh",
      "overflow-y": "auto"
    }
  }, [_c('MexSessionReport', {
    attrs: {
      "report": _vm.report
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.reportVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "场次回放",
      "width": "1180"
    },
    model: {
      value: (_vm.replayVisible),
      callback: function($$v) {
        _vm.replayVisible = $$v
      },
      expression: "replayVisible"
    }
  }, [(_vm.replay) ? _c('p', [_vm._v("场次 " + _vm._s(_vm.replay.session && _vm.replay.session.id) + " / " + _vm._s(_vm.statusLabel(_vm.replay.session && _vm.replay.session.status, (_vm.replay.result && (_vm.replay.result.publishStatus || _vm.replay.result.flags)) || (_vm.replay.session && (_vm.replay.session.publishStatus || _vm.replay.session.flags)))) + " / 定级 " + _vm._s(_vm.replay.session && _vm.replay.session.placementLevel || '—'))]) : _vm._e(), _vm._v(" "), (_vm.replay) ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("点左侧箭头可看原题、知识点和解析")]) : _vm._e(), _vm._v(" "), (_vm.replay) ? _c('div', {
    staticClass: "mex-replay-table-wrap"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.itemColumns,
      "data": _vm.replay.replayItems || [],
      "size": "small"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.replay && _vm.replay.result) ? _c('div', {
    staticClass: "mex-replay-result"
  }, [_c('h4', [_vm._v("成绩摘要")]), _vm._v(" "), _c('div', {
    staticClass: "mex-replay-hero"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.replay.result.title || '—'))]), _vm._v("\n          · " + _vm._s(_vm.medalLabel(_vm.replay.result.medal)) + "\n          · 百分制 " + _vm._s(_vm.dash(_vm.replay.result.totalScore)) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          定级 " + _vm._s(_vm.replay.result.placementLevel || '—') + "\n          · 升班 " + _vm._s(_vm.promotionLabel(_vm.replay.result.promotion)) + "\n          · " + _vm._s(_vm.flagsLabel(_vm.replay.result.flags)) + "\n        ")])]), _vm._v(" "), _c('h4', [_vm._v("模块分")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.moduleColumns,
      "data": _vm.moduleRows,
      "size": "small"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("雷达维度")]), _vm._v(" "), (_vm.radarPlot) ? _c('div', {
    staticClass: "mex-radar-wrap"
  }, [_c('svg', {
    staticClass: "mex-radar",
    attrs: {
      "viewBox": "0 0 360 320"
    }
  }, [_vm._l((_vm.radarPlot.rings), function(ring, i) {
    return _c('polygon', {
      key: 'ring' + i,
      staticClass: "mex-radar-ring",
      attrs: {
        "points": ring
      }
    })
  }), _vm._v(" "), _vm._l((_vm.radarPlot.axes), function(ax, i) {
    return _c('line', {
      key: 'axis' + i,
      staticClass: "mex-radar-axis",
      attrs: {
        "x1": _vm.radarPlot.cx,
        "y1": _vm.radarPlot.cy,
        "x2": ax.x2,
        "y2": ax.y2
      }
    })
  }), _vm._v(" "), _c('polygon', {
    staticClass: "mex-radar-area",
    attrs: {
      "points": _vm.radarPlot.polygon
    }
  }), _vm._v(" "), _vm._l((_vm.radarPlot.dots), function(d, i) {
    return _c('circle', {
      key: 'dot' + i,
      staticClass: "mex-radar-dot",
      attrs: {
        "cx": d.x,
        "cy": d.y,
        "r": "3.5"
      }
    })
  }), _vm._v(" "), _vm._l((_vm.radarPlot.axes), function(ax, i) {
    return _c('text', {
      key: 'lab' + i,
      staticClass: "mex-radar-label",
      attrs: {
        "x": ax.lx,
        "y": ax.ly,
        "text-anchor": "middle"
      }
    }, [_c('tspan', {
      attrs: {
        "x": ax.lx,
        "dy": "0"
      }
    }, [_vm._v(_vm._s(ax.label))]), _vm._v(" "), _c('tspan', {
      attrs: {
        "x": ax.lx,
        "dy": "14"
      }
    }, [_vm._v(_vm._s(ax.score))])])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "mex-radar-legend"
  }, _vm._l((_vm.radarRows), function(row) {
    return _c('li', {
      key: row.label
    }, [_c('span', [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row.score))])])
  }), 0)]) : _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("暂无雷达数据")]), _vm._v(" "), (_vm.replay.result.benchmarkVisible === 1) ? _c('p', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v("\n        全国均分 " + _vm._s(_vm.dash(_vm.replay.result.nationalAvgScore)) + " · 全国百分位 " + _vm._s(_vm.dash(_vm.replay.result.nationalPercentile)) + "\n        · 同城均分 " + _vm._s(_vm.dash(_vm.replay.result.cityAvgScore)) + " · 同城百分位 " + _vm._s(_vm.dash(_vm.replay.result.cityPercentile)) + "\n        · 样本 " + _vm._s(_vm.dash(_vm.replay.result.benchmarkSampleN)) + "\n      ")]) : _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("对标样本不足，全国/同城分数环不展示")])], 1) : (_vm.replay) ? _c('p', {
    staticClass: "mex-dim-hint",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("暂无成绩（场次尚未出分）")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.replayVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.fullTextTitle,
      "width": "560"
    },
    model: {
      value: (_vm.fullTextVisible),
      callback: function($$v) {
        _vm.fullTextVisible = $$v
      },
      expression: "fullTextVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "word-break": "break-all",
      "white-space": "pre-wrap",
      "max-height": "360px",
      "overflow": "auto"
    }
  }, [_vm._v(_vm._s(_vm.fullText))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.fullTextVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15782726","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mex/MexSessionList.vue
// module id = 1638
// module chunks = 8